import React from 'react'
import {List, Row, Col} from "antd";
import {UserOutlined, ApiOutlined, CalendarOutlined, ApartmentOutlined} from "@ant-design/icons";
import userDateFormatter from "../../../services/formatters/userDateFormatter";
import Text from "antd/es/typography/Text";
import './request-log.css'

const RequestLog = ({data}) => {
    const {rqL} = data

    const viewStyle = {
        height: '50vh',
        overflowY: 'auto',
    }

    return (
        <React.Fragment>
            <div className={'rql-view'} style={viewStyle}>
                <List
                    itemLayout={'vertical'}
                    size={'small'}
                    dataSource={rqL}
                    renderItem={item => {
                        return (
                            <List.Item>
                                <PanelItem item={item}/>
                            </List.Item>
                        )
                    }}
                />
            </div>
        </React.Fragment>
    )
}
export default RequestLog

const PanelItem = ({item: {cb, ru, cd, ra}}) => {

    const containerStyle = {
        display: 'flex',
        alignItems: 'center'
    }

    const textStyle = {
        marginLeft: '8px'
    }

    return (
        <React.Fragment>
            <div>
                <Row justify={'space-between'}>
                    <Col style={{marginRight: '32px'}}>
                        <div style={containerStyle}><UserOutlined/><Text style={textStyle}
                                                                         type={'secondary'}>{cb}</Text></div>
                    </Col>
                    <Col>
                        <div style={containerStyle}><ApiOutlined/><Text style={textStyle} type={'secondary'}>{ru}</Text>
                        </div>
                    </Col>
                </Row>
                <Row justify={'space-between'}>
                    <Col style={{marginRight: '32px'}}>
                        <div style={containerStyle}><ApartmentOutlined/><Text style={textStyle}
                                                                              type={'secondary'}>{ra}</Text></div>
                    </Col>
                    <Col>
                        <div style={containerStyle}><CalendarOutlined/><Text style={textStyle}
                                                                             type={'secondary'}>{userDateFormatter(cd)}</Text>
                        </div>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}